import { render, staticRenderFns } from "./ViewItem.vue?vue&type=template&id=0fceaaeb&"
import script from "./ViewItem.vue?vue&type=script&lang=js&"
export * from "./ViewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports